import { useSelector } from 'react-redux';
import { isCtaDTTEnabled } from 'pricing-pages-ui/constants/PublicCtaDttEnabled';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { highlightedSkuIdsSelector, productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
// Common props that are used for merch card AuthedCTAs, and the loading state buttons
export const useMerchCardPublicCTAsProps = ({
  skuId,
  containterStyle = {},
  selectedTab
}) => {
  const {
    productLevel,
    productLine
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }) || {});
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  let numPurchaseMotions = 1;

  if (isCtaDTTEnabled({
    productLine,
    productLevel
  })) {
    numPurchaseMotions = numPurchaseMotions + 1;
  }

  const hasSkuWithCtaDttEnabled = useSelector(state => {
    const highlightedSkuIds = highlightedSkuIdsSelector(state, {
      productLine,
      selectedTab
    });
    return highlightedSkuIds.some(highlightedSkuId => {
      const highlightedProduct = productForSkuIdSelector(state, {
        skuId: highlightedSkuId
      });
      return isCtaDTTEnabled(highlightedProduct);
    });
  });
  let maxNumPurchaseMotions = 1;

  if (hasSkuWithCtaDttEnabled) {
    maxNumPurchaseMotions = maxNumPurchaseMotions + 1;
  }

  const marginBottomMap = {
    1: '56px',
    2: '110px'
  };
  const updatedStyled = Object.assign({
    marginBottom: marginBottomMap[maxNumPurchaseMotions - numPurchaseMotions]
  }, containterStyle);
  return {
    numPurchaseMotions,
    // used for loading state only
    maxNumPurchaseMotions,
    // used for loading state only
    hasPricingAndPurchasingSucceeded,
    containterStyle: updatedStyled
  };
};